import { render } from "./FriendsCom.vue?vue&type=template&id=7756bdae"
import script from "./FriendsCom.vue?vue&type=script&lang=js"
export * from "./FriendsCom.vue?vue&type=script&lang=js"

import "./FriendsCom.vue?vue&type=style&index=0&id=7756bdae&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__